export const appRoutes = {

    DASHBOARD                    : '/dashboard',
    NATIONAL_TARGETS             : '/national-targets',
    DATABASE                     : '/database/:identifier',
    WORKFLOWS_REQUESTS           : '/workflows/requests',

    NATIONAL_TARGETS_ANALYZER               : '/national-targets/analyzer',
    NATIONAL_TARGETS_MY_COUNTRY             : '/national-targets/my-country',
    NATIONAL_TARGETS_MY_COUNTRY_PART_I      : '/national-targets/my-country/part-1',
    NATIONAL_TARGETS_MY_COUNTRY_PART_I_EDIT : '/national-targets/my-country/part-1/:identifier/edit',
    NATIONAL_TARGETS_MY_COUNTRY_PART_I_VIEW : '/national-targets/my-country/part-1/:identifier/view',
    NATIONAL_TARGETS_MY_COUNTRY_PART_I_NEW  : '/national-targets/my-country/part-1/new',
    NATIONAL_TARGETS_MY_COUNTRY_PART_II     : '/national-targets/my-country/part-2',
    NATIONAL_TARGETS_MY_COUNTRY_PART_II_EDIT: '/national-targets/my-country/part-2/:identifier/edit',
    NATIONAL_TARGETS_MY_COUNTRY_PART_II_VIEW: '/national-targets/my-country/part-2/:identifier/view',
    
    NATIONAL_REPORTS_NBSAP                      : '/nbsaps',
    NATIONAL_REPORTS_NBSAP_ANALYZER             : '/nbsaps/analyzer',
    NATIONAL_REPORTS_NBSAP_MY_COUNTRY_LIST      : '/nbsaps/my-country',
    NATIONAL_REPORTS_NBSAP_MY_COUNTRY_VIEW      : '/nbsaps/my-country/:identifier/view',
    NATIONAL_REPORTS_NBSAP_MY_COUNTRY_EDIT      : '/nbsaps/my-country/:identifier/edit',
    NATIONAL_REPORTS_NBSAP_MY_COUNTRY_NEW       : '/nbsaps/my-country/new',

    NATIONAL_REPORTS            : '/national-reports',
    NATIONAL_REPORTS_NR6        : 'https://chm.cbd.int/database?schema_s=nationalReport6',
    NATIONAL_REPORTS_NR7        : '/national-reports/nr7',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT               : '/national-reports/nr7/my-country/edit',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_INDICATOR_DATA: '/national-reports/nr7/my-country/edit/indicator-data',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_OVERVIEW      : '/national-reports/nr7/my-country/edit/overview',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_SECTION_I     : '/national-reports/nr7/my-country/edit/section-I',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_SECTION_II    : '/national-reports/nr7/my-country/edit/section-II',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_SECTION_III   : '/national-reports/nr7/my-country/edit/section-III',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_SECTION_IV    : '/national-reports/nr7/my-country/edit/section-IV',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_SECTION_V     : '/national-reports/nr7/my-country/edit/section-V',
    NATIONAL_REPORTS_NR7_MY_COUNTRY_EDIT_SECTION_OTHER_INFORMATION : '/national-reports/nr7/my-country/edit/section-other-information',
    
    
    TAXONOMY                                  : '/taxonomy',
    TAXONOMY_GBF                              : '/taxonomy/gbf',
    TAXONOMY_GBF_GOALS                        : '/taxonomy/gbf/goals',
    TAXONOMY_GBF_GOAL_DETAILS                 : '/taxonomy/gbf/goals/:identifier',
    TAXONOMY_GBF_GOAL_INDICATOR_TYPE_DETAILS  : '/taxonomy/gbf/goals/:identifier/:type', //component/comp etc
    TAXONOMY_GBF_TARGETS                      : '/taxonomy/gbf/targets',
    TAXONOMY_GBF_TARGET_DETAILS               : '/taxonomy/gbf/targets/:identifier',
    TAXONOMY_GBF_TARGET_INDICATOR_TYPE_DETAILS: '/taxonomy/gbf/targets/:identifier/:type',
    TAXONOMY_GBF_INDICATORS                   : '/taxonomy/gbf/indicators',
    TAXONOMY_GBF_INDICATOR_DETAILS            : '/taxonomy/gbf/indicators/:identifier',
    TAXONOMY_GBF_ANY                          : '/taxonomy/gbf/:identifier',
    // TAXONOMY_GBF_INDICATOR_DETAILS: '/taxonomy/gbf/:target/:identifier',
}